<template>
  <v-card :elevation="$root.ele" class="order mt-4 d-flex">
    <div class="order-left">
      <Left @input="onInput" ref="left" v-model="template"></Left>
    </div>
    <div class="order-left-mobile ">
      <v-autocomplete
        outlined
        hide-details=""
        class="ma-4"
        dense
        v-model="template"
        :items="templates"
        @input="onInput(template)"
        item-text="name"
        item-value="id"
      >
      </v-autocomplete>
      <v-divider></v-divider>
    </div>
    <div class="order-right">
      <Right ref="right"></Right>
    </div>
  </v-card>
</template>

<script>
import Left from "./order/Left";
import Right from "./order/Right.vue";
export default {
  components: { Left, Right },
  data() {
    return {
      template: ""
    };
  },
  computed: {
    templates() {
      return this.$store.getters.templates.filter(item => {
        return item.type == 0;
      });
    }
  },
  watch: {
    templates() {
      this.init();
    }
  },
  methods: {
    init() {
      if (this.template === "" && this.templates[0]) {
        this.onInput(this.templates[0].id);
      }
    },
    onInput(id) {
      this.template = id;
      this.$refs.left.id = id;
      this.$refs.right.init(id);
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="scss">
.order {
  width: 100%;
  height: calc(100vh - 200px);
  @media only screen and (max-width: 600px) {
    flex-direction: column;
    height: auto;
  }
  &-left {
    width: 300px;
    border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
    overflow-y: auto;
    height: calc(100vh - 200px);
    @media only screen and (max-width: 600px) {
      display: none;
    }
    &-mobile {
      display: none;
      @media only screen and (max-width: 600px) {
        display: block;
      }
    }
  }
  &-right {
    flex: 1;
    overflow-y: auto;
    height: calc(100vh - 200px);
  }
}
</style>
